import { useState, useCallback, useRef, useEffect } from "react";

export const useDropdownState = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const dropdownRefs = useRef({});
  const propertyTypeDropdownRef = useRef(null);

  // Handle dropdown toggle
  const toggleDropdown = useCallback((dropdownKey, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setActiveDropdown((prev) => (prev === dropdownKey ? null : dropdownKey));
  }, []);

  // Close dropdown
  const closeDropdown = useCallback(() => {
    setActiveDropdown(null);
  }, []);

  // Create ref callback function
  const createRefCallback = useCallback((fieldKey) => {
    return (ref) => {
      if (ref) {
        dropdownRefs.current[fieldKey] = ref;
      }
    };
  }, []);

  // Handle click outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const targetElement = event.target;

      // Check if click is outside all dropdowns
      let isOutsideAllDropdowns = true;

      if (propertyTypeDropdownRef.current?.contains(targetElement)) {
        isOutsideAllDropdowns = false;
      }

      // Check other dropdown refs
      Object.values(dropdownRefs.current).forEach((ref) => {
        if (ref?.contains(targetElement)) {
          isOutsideAllDropdowns = false;
        }
      });

      if (isOutsideAllDropdowns) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return {
    activeDropdown,
    toggleDropdown,
    closeDropdown,
    createRefCallback,
    propertyTypeDropdownRef,
    dropdownRefs,
  };
};
